'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeToThreadChannels = exports.subscribeToThreadChannelsAction = undefined;

var _reduxActions = require('redux-actions');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _pubSubClientGetters = require('conversations-internal-pub-sub/redux/selectors/pubSubClientGetters');

var _getPersistedThreadsArray = require('../../threads/selectors/getPersistedThreadsArray');

var _onMessageReceived = require('../../pubsub/actions/onMessageReceived');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var subscribeToThreadChannelsAction = exports.subscribeToThreadChannelsAction = (0, _reduxActions.createAction)(ActionTypes.SUBSCRIBE_TO_THREAD_CHANNELS);

var subscribeToThreadChannels = exports.subscribeToThreadChannels = function subscribeToThreadChannels() {
  return function (dispatch, getState) {
    dispatch(subscribeToThreadChannelsAction());

    var client = (0, _pubSubClientGetters.getPubSubClient)(getState());
    var threads = (0, _getPersistedThreadsArray.getPersistedThreadsArray)(getState());

    var subscriptions = threads.reduce(function (acc, thread) {
      var channel = (0, _threadGetters.getChannel)(thread);
      var threadId = (0, _threadGetters.getThreadId)(thread);

      acc[channel] = function (message) {
        return dispatch((0, _onMessageReceived.onMessageReceived)({ threadId: threadId, message: message, channel: channel }));
      };
      return acc;
    }, {});

    var promise = client.updateSubscriptions(subscriptions);

    promise.done();
    return promise;
  };
};